import { displayRole, type User } from 'shared/modelTypes/index';
import { Badge } from './Badge';
import { Button } from './Button';
import { ChevronRight, Plus } from 'lucide-static';
import { Icon } from './Icon';
import { Table, Td, Th, TrBody, TrHead } from './TableComponents';

type UserListProps = {
	users: User[];
};
export function UserList({ users }: UserListProps) {
	return (
		<div class="flex flex-col gap-3">
			<div class="flex gap-4">
				<h2 class="text-gray-700 dark:text-gray-300">Users</h2>
				<Button size="sm" href="/dashboard/users/new">
					New User
					<Icon icon={Plus} class="size-4 text-theme-100" />
				</Button>
				<Button size="sm" mode="tertiary" href="/dashboard/settings">
					Visit Your Profile
					<Icon icon={ChevronRight} class="size-4 text-gray-500" />
				</Button>
			</div>
			<div class="max-w-[400px]">
				{!users.length && <small>No Users.</small>}
				{!!users.length && (
					<Table>
						<thead>
							<TrHead>
								<Th>Name</Th>
								<Th>Email</Th>
								<Th>Role</Th>
							</TrHead>
						</thead>
						<tbody>
							{users.map((user) => {
								return (
									<TrBody
										data-href={'/dashboard/users/' + user._id?.split('/')[1]}
										tabindex="0"
										role="link"
										class="cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700"
									>
										<Td>
											{user.firstName} {user.lastName}
										</Td>
										<Td class="border-gray-200 p-3 text-gray-500 dark:text-gray-400">{user.email}</Td>
										<Td>
											<Badge status="info">{displayRole(user.role)}</Badge>
										</Td>
									</TrBody>
								);
							})}
						</tbody>
					</Table>
				)}
			</div>
		</div>
	);
}
